import { AccessMode } from './visitorPassAccess';

export interface VisitorPassInput {
  propertyId: string;
  unitId?: string;
  passType: 'visitor' | 'delivery';
  visitorName: string;
  phone: string;
  email?: string;
  validFrom: Date;
  validUntil: Date;
  accessMode: AccessMode;
  deviceIds: string[];
  consentForm?: { enabled: true; title: string; text: string; acknowledgement: string };
  deliveryInstructions?: string;
}

export function buildVisitorPassPayload(input: VisitorPassInput) {
  if (!input.propertyId || !input.visitorName.trim() || !input.phone.trim()) {
    throw new Error('Property, visitor name, and verification phone are required');
  }
  if (!Number.isFinite(input.validFrom.getTime()) || !Number.isFinite(input.validUntil.getTime()) || input.validUntil <= input.validFrom) {
    throw new Error('Access must end after it starts');
  }
  if (input.accessMode === 'selected' && (!input.deviceIds.length || input.deviceIds.includes('*'))) {
    throw new Error('Select at least one authorized door');
  }
  if (input.consentForm?.enabled && !input.consentForm.text.trim()) {
    throw new Error('Consent disclosure is required when consent is enabled');
  }
  return {
    property_id: input.propertyId,
    unit_id: input.unitId || undefined,
    pass_type: input.passType,
    visitor_name: input.visitorName.trim(),
    phone: input.phone.trim(),
    email: input.email?.trim() || undefined,
    valid_from: input.validFrom.toISOString(),
    valid_until: input.validUntil.toISOString(),
    access_scope_mode: input.accessMode,
    access_scope: input.accessMode === 'selected' ? [...input.deviceIds] : [],
    second_factor_required: true,
    consent_form: input.consentForm,
    delivery_instructions: input.deliveryInstructions?.trim() || undefined,
  };
}
